export default __webpack_public_path__ + "static/media/language.f90476c6.svg";